const closeIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 26 24" fill="none"><line x1="1.33273" y1="23.6464" x2="23.9601" y2="1.019" stroke="currentColor"/><line x1="2.03983" y1="0.646416" x2="24.6672" y2="23.2738" stroke="currentColor"/></svg>`;
const roundedTriangleIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 80.19" fill="currentColor"><path d="M46.4,1.97c1.67-2.62,5.5-2.62,7.17,0l45.75,71.67c1.81,2.83-.22,6.54-3.58,6.54l-91.48,.02c-3.36,0-5.39-3.71-3.59-6.54L46.4,1.97h0Z" /></svg>`;
  
function similarProducts({ size, width, similarSection, similarList }) {
  const similarData = similarList?.dataset.similarList;
  if (!similarData) return;

  const products = similarData
    .split(',')
    .filter(Boolean)
    .map(entry => {
      const [handle, combos] = entry.split('::');
      const comboList = combos ? combos.split('|').filter(Boolean) : [];

      return {
        handle,
        combos: comboList
      };
    });

  const targetCombo = `${size}_${width}`;

  const filteredProducts = products.filter(product =>
    product.combos.includes(targetCombo)
  );

  if (filteredProducts.length === 0) return;

  similarSection.classList.remove('hidden');

  similarList.innerHTML = `
    <swiper-carousel
      data-space-between="8"
      data-slides-per-view-mobile="2.2"
      data-slides-per-view="2.3"
      data-external-nav-buttons="pdp-similar-slider"
      class="w-full"
    >
      <button data-prev="pdp-similar-slider" class="button-slider disabled:hidden absolute left-0 top-1/2 -translate-y-1/2 z-10 border-none hover:bg-transparent px-4" data-prev>
        <svg class="transform -scale-x-100" xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M1.60926 0L0 1.72611L6.78148 9L0 16.2739L1.60926 18L10 9L1.60926 0Z" fill="black"/>
        </svg>
      </button>
      <button data-next="pdp-similar-slider" class="button-slider disabled:hidden absolute right-0 top-1/2 -translate-y-1/2 z-10 border-none hover:bg-transparent px-4" data-next>
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M1.60926 0L0 1.72611L6.78148 9L0 16.2739L1.60926 18L10 9L1.60926 0Z" fill="black"/>
        </svg>
      </button>
      <div class="swiper-wrapper">
        ${filteredProducts.slice(0, 6).map(product => `
          <div class="swiper-slide">
            <intersection-loader 
              data-url="/products/${product.handle}" 
              data-section-id="product-mini-tile"
              class="!aspect-[16/17.5]" 
            ></intersection-loader>                    
          </div>
        `).join('')}
      </div>
    </swiper-carousel>
  `;
}

const updateAverageRating = (judgeme_observer) => {
  const parentElement = document.querySelector('.jdgm-rev-widg');
  
  if (parentElement) {
    const averageRating = parentElement.getAttribute('data-average-rating');
    const summaryAverageElement = document.querySelector('.jdgm-rev-widg__summary-average');

    if (averageRating == null || averageRating == '0.00') {
      document.querySelector('[data-judgeme-review]').style.display = 'none';
      document.querySelector('[data-disclaimer-container]').style.display = 'none';

      judgeme_observer.disconnect();
    }
      
    if (summaryAverageElement && averageRating !== null) {
      summaryAverageElement.textContent = averageRating;

      judgeme_observer.disconnect();
    }
  }
};

function populateSelectedProductImages() {
  const mobile_media = [...this.selectedProduct.media];
  mobile_media.sort((a, b) =>  b.alt?.toLowerCase().includes('first-image') - a.alt?.toLowerCase().includes('first-image'));

  this.imagesWrapper.innerHTML = `
    <!-- Mobile Product Images -->
    <div class="lg:hidden flex flex-col gap-4">
      <div class="pdp-thumbs px-4 order-2">
        <swiper-carousel 
          data-slides-per-view="5.5"
          data-slides-per-view="5.5"
          data-space-between="8"
          data-mobile-space-between="8"
          data-free-mode="true"
          data-watch-slides-progress="true"
          id="thumbnails-${this.selectedProduct.id}"
        >
          <div class="swiper-wrapper">
            ${mobile_media.map((media) => `
              <div class="swiper-slide !max-w-[68px] sm:!max-w-[150px] ${media.src.includes(`DrEmily`) ? `hide-video` : ``}">
                <img src="${media.src}" alt="${media.alt || ''}" width="80" height="120" />
              </div>
            `
            ).join('')}
          </div>
        </swiper-carousel>
      </div>
      <div class="relative block lg:hidden w-[calc(100vw-32px)] mx-auto overflow-visible clip">
        <swiper-carousel 
          data-mobile-image-loop
          data-centered="true"
          data-centered-bounds="true"
          data-slides-per-view="1"
          data-space-between="8"
          data-product-images
          data-thumbs="thumbnails-${this.selectedProduct.id}"
          class=""
        >

          ${this.selectedProduct.tags.some(tag => tag.toLowerCase().includes('feature:hands-free')) ? (() => {
            const videoMedia = this.selectedProduct.media.find(
              (m) => m.media_type === 'video' && m.alt === 'autoplay'
            );
            const videoIndex = this.selectedProduct.media.indexOf(videoMedia);
            return videoMedia
              ? `
            <div class="absolute top-2 right-2 w-24 h-16 rounded-md z-10 overflow-hidden bg-secondaryLight transition-all duration-200" data-mini-video>
              <button data-drawer-action="open" data-drawer-id="video_${videoIndex}" class="block w-full h-full">
                <video
                  autoplay
                  muted
                  loop
                  playsinline
                  class="block w-full h-full object-cover aspect-[96/64]"
                  src="${videoMedia.sources[1].url}"
                  poster="${videoMedia.preview_image?.src || ''}"
                  style="clip-path: none"
                ></video>
              </button>
            </div>` : '';
          })() : '' }

          <div data-product-images="main" class="swiper-wrapper mobile-pdp-swiper">
            ${mobile_media.map((media, i) => `
            <div class="swiper-slide rounded-lg aspect-[1.42/1] ${media.alt != 'no-mix' ? `[&_img]:mix-blend-multiply` : ``} overflow-hidden bg-secondaryLight [&_img]:object-contain [&_img]:object-center ${media.src.includes(`DrEmily`) ? `hide-video` : ``}">
            ${media.media_type == 'video' ? `
              <div role="button" data-drawer-action="open"  data-drawer-id="video_${i}"  class="absolute w-full h-full z-10 group paused">
                ${ media.alt.includes('autoplay') ? `` : 
                  `<span 
                    data-play 
                    class="
                      absolute
                      w-24
                      h-24
                      top-1/2 
                      left-1/2 
                      flex
                      justify-center
                      items-center
                      -translate-x-1/2  
                      -translate-y-1/2 
                      opacity-100
                      text-primaryLight 
                      transform 
                      rotate-90
                      bg-transparent
                      border-primaryLight
                      border-[3px]
                      rounded-full
                      transition-all 
                      duration-200  
                      pointer-events-none 
                      group-hover:scale-110
                      [&_svg]:w-12
                      [&_svg]:h-12
                      [&_svg]:[filter:drop-shadow(0_0_0.45rem_rgba(0,0,0,0.45))]
                      [box-shadow:0_0_10px_4px_rgba(0,0,0,0.15),0_0_20px_8px_rgba(0,0,0,0.05)]
                    "
                  >
                  ${roundedTriangleIcon}
                </span>` }
              </div>
              <template data-direction="center" data-drawer-content="video_${i}">
                <div class="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-primaryLight rounded-lg">
                  <div class="flex items-center px-5 py-2.5">
                  <button 
                      aria-label="Close video modal"
                      role="button" 
                      data-drawer-action="close"
                      data-drawer-id="video_${i}" 
                      class="block w-5 h-5 text-primaryDark absolute right-5 top-2.5"
                    >
                    ${closeIcon}
                    </button>
                  </div>
                  <div class="p-5 max-lg:w-screen">
                    ${this.loadImage(media, i)}
                  </div>
                </div>
              </template>
              ${media.media_type == 'video' && media.alt.includes('autoplay') ? 
                `${this.loadImage({ ...media, media_type: media.media_type }, i)}` : 
                `${this.loadImage({ ...media, media_type: media.media_type }, i, true)}`
              }
            ` : this.loadImage(media, i)}     
            ${this.selectedProduct.badge && i === 0 ? 
                `<div class="absolute top-2 right-2 h-20 w-20">
                  <img class="object-contain" data-badge loading="lazy" src="${this.selectedProduct.badge}" height="auto" width="auto" />
                </div>` : 
                `` 
              }           
            </div>
          `).join('')}
          </div>
        </swiper-carousel>
      </div>
    </div>
    
    <!-- Desktop Product Images -->
    <div data-desktop-images>
      <div class="hidden lg:block">
        <div class="flex gap-4 items-start">
          <div data-thumbs-wrapper class="w-20 shrink-0 sticky top-[calc(var(--header-height,0px)+16px)] self-start hidden">
            <div
              data-desktop-thumbs
              class="max-h-[calc(100vh-(var(--header-height,0px)+32px))] overflow-y-auto overflow-x-hidden pr-1 flex flex-col gap-3"
            >
              ${this.selectedProduct.media.map((media, i) => (`
                <button
                  type="button"
                  data-thumb-target="desktop-media-${i}"
                  class="group border border-secondaryLight rounded overflow-hidden"
                >
                    <img
                      src="${media.poster ? media.poster : media.src}"
                      alt="${media.alt || ''}"
                      class="block w-full h-full object-cover"
                      loading="lazy"
                      width="80"
                      height="80"
                    />
                </button>
              `)).join('')}
            </div>
          </div>

          <div class="flex-1 min-w-0">
            <div data-desktop-images-wrapper class="grid grid-cols-2 max-xl:grid-cols-1 gap-4 [&_.img]:mix-blend-multiply [&_.img]:w-full" data-product-images="main">
              ${this.selectedProduct.media.map((media, i) => (`
                <div
                  id="desktop-media-${i}"
                  data-index="${i}"
                  class="bg-secondaryLight aspect-[1.42/1] ${media.alt != 'no-mix' ? `[&_img]:mix-blend-multiply` : ``} lg:rounded-lg overflow-hidden ${media.media_type == 'video' ? `cursor-pointer [&>div]:w-auto [&>div]:h-full [&>div]:object-cover [&_img]:w-full [&_img]:h-full [&_img]:object-cover` : `cursor-zoom-in`} relative"
                >
                  ${i == 0 ? `<span class="absolute bg-primaryBrand rounded-full left-4 bottom-4 z-10 justify-center items-center flex p-2 lg:p-2.5 [&_svg]:w-4 [&_svg]:h-4 pointer-events-none">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.16 13.16" width="100%" height="100%" stroke="currentColor">
                      <path d="M3.81,5.89h2.08m0,0h2.08m-2.08,0V3.81m0,2.08v2.08m4.15,2.08l2.77,2.77M.35,5.89c0,1.47,.58,2.88,1.62,3.92,1.04,1.04,2.45,1.62,3.92,1.62s2.88-.58,3.92-1.62c1.04-1.04,1.62-2.45,1.62-3.92s-.58-2.88-1.62-3.92C8.76,.93,7.35,.35,5.89,.35S3.01,.93,1.97,1.97C.93,3.01,.35,4.42,.35,5.89Z" style="fill:none; stroke:#1c1e1d; stroke-linecap:round; stroke-linejoin:round; stroke-width:.69px;"/>
                    </svg>
                  </span>` : ``}

                  ${media.media_type == 'video' ? `
                    <button type="button" data-drawer-action="open" data-drawer-id="video_${i}" class="absolute w-full h-full z-10 group paused">
                      ${media.alt?.includes('autoplay') ? `` : `
                        <span data-play class="absolute w-24 h-24 top-1/2 left-1/2 flex justify-center items-center -translate-x-1/2 -translate-y-1/2 opacity-100 text-primaryLight transform rotate-90 bg-transparent border-primaryLight border-[3px] rounded-full transition-all duration-200 pointer-events-none group-hover:scale-110 [&_svg]:w-12 [&_svg]:h-12 [&_svg]:[filter:drop-shadow(0_0_0.45rem_rgba(0,0,0,0.45))] [box-shadow:0_0_10px_4px_rgba(0,0,0,0.15),0_0_20px_8px_rgba(0,0,0,0.05)]">
                          ${roundedTriangleIcon}
                        </span>
                      `}
                    </button>
                  ` : ``}

                  ${this.selectedProduct.badge && i === 0 ? `
                    <div class="absolute top-5 right-2 h-24 w-24">
                      <img class="object-contain" data-badge loading="lazy" src="${this.selectedProduct.badge}" height="auto" width="auto" />
                    </div>
                  ` : ``}

                  ${media.media_type == 'video' && media.alt?.includes('autoplay')
                    ? this.loadImage({ ...media, media_type: media.media_type }, i)
                    : this.loadImage({ ...media, media_type: media.media_type }, i, true)
                  }
                </div>
              `)).join('')}
            </div>
          </div>
        </div>
      </div>
    </div>
  `; 

  // Thumbnails A/B Test
  const thumbs = this.imagesWrapper.querySelector(`[data-desktop-thumbs]`);
  const wrapper = this.imagesWrapper.querySelector(`[data-desktop-images-wrapper]`);
  if (!thumbs || !wrapper) return;

  const buttons = Array.from(thumbs.querySelectorAll(`[data-thumb-target]`));
  const targets = buttons
    .map((btn) => this.imagesWrapper.querySelector(`#${btn.getAttribute(`data-thumb-target`)}`))
    .filter(Boolean);

  const set_active = (id) => {
    buttons.forEach((btn) => {
      btn.classList.toggle(
        `is-active`,
        btn.getAttribute(`data-thumb-target`) === id
      );
    });
  };

  thumbs.addEventListener(`click`, (e) => {
    const btn = e.target.closest(`[data-thumb-target]`);
    if (!btn) return;

    const id = btn.getAttribute(`data-thumb-target`);
    const el = this.imagesWrapper.querySelector(`#${id}`);
    if (!el) return;

    el.scrollIntoView({ behavior: `smooth`, block: `start` });
  });

  const headerHeightRaw = getComputedStyle(document.documentElement)
  .getPropertyValue('--header-height')
  .trim();

  const headerHeight = Number.isFinite(parseFloat(headerHeightRaw))
    ? parseFloat(headerHeightRaw)
    : 0;

  const io = new IntersectionObserver(
    (entries) => {
      const visible = entries
        .filter((e) => e.isIntersecting)
        .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];

      if (visible?.target?.id) set_active(visible.target.id);
    },
    {
      root: null,
      threshold: 0.2,
      rootMargin: `-${headerHeight + 16}px 0px -60% 0px`,
    }
  );

  targets.forEach((el) => io.observe(el));

  if (targets[0]?.id) set_active(targets[0].id);
}

function populateSelectedProductPrice(product) {
  if (!product || !this.displayPrice) return;
  const shopPay = this.querySelector('shopify-payment-terms')?.shadowRoot.querySelector('#shopify-installments')?.querySelector('#shopify-installments-content');
  setTimeout(() => {
    if(((product?.price / 100).toFixed(2)) > 50 && shopPay != undefined) {
      let splitPrice = ((product?.price / 100) / 4)
      shopPay.innerHTML = `
        Pay in 4 interest-free installments of <b>$${ (Math.round(splitPrice * 100) /100).toFixed(2) }</b> <div class="mobile-injected">with 
        <div class="lg:hidden inline-flex align-middle text-purple-primary"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 99 25" class="text-inherit h-[14px] w-[59px]"><path fill="currentColor" d="M70.842 7.915h2.25c1.561 0 2.328.642 2.328 1.715 0 1.074-.739 1.715-2.259 1.715h-2.32v-3.43ZM80.525 16.142c-.879 0-1.227-.474-1.227-.948 0-.642.725-.935 2.147-1.102l1.115-.125c-.07 1.227-.892 2.175-2.035 2.175Z"></path><path fill="currentColor" fill-rule="evenodd" d="M65.645.5a3.64 3.64 0 0 0-3.64 3.64V20.7a3.64 3.64 0 0 0 3.64 3.64h29.668a3.64 3.64 0 0 0 3.64-3.64V4.14A3.64 3.64 0 0 0 95.314.5H65.645Zm5.197 16.674v-4.197h2.64c2.412 0 3.695-1.353 3.695-3.402 0-2.05-1.283-3.277-3.695-3.277h-4.341v10.876h1.7Zm9.334.223c1.297 0 2.147-.572 2.538-1.548.112 1.088.767 1.645 2.189 1.269l.014-1.157c-.572.055-.683-.154-.683-.753v-2.845c0-1.673-1.102-2.663-3.138-2.663-2.008 0-3.165 1.004-3.165 2.705h1.562c0-.809.572-1.297 1.576-1.297 1.06 0 1.547.46 1.534 1.255v.363l-1.8.195c-2.021.223-3.137.99-3.137 2.329 0 1.101.781 2.147 2.51 2.147Zm9.906.32c-.711 1.73-1.855 2.245-3.64 2.245h-.766V18.54h.822c.977 0 1.45-.307 1.966-1.185L85.3 9.923h1.757l2.259 5.424 2.008-5.424h1.715l-2.956 7.795Z" clip-rule="evenodd"></path><path fill="currentColor" d="M6.992 11.055c-2.359-.509-3.41-.708-3.41-1.612 0-.85.711-1.274 2.134-1.274 1.25 0 2.165.544 2.839 1.61.05.081.155.11.241.066l2.655-1.335a.186.186 0 0 0 .076-.259c-1.102-1.9-3.137-2.94-5.818-2.94C2.188 5.311 0 7.037 0 9.781c0 2.915 2.664 3.651 5.027 4.16 2.362.51 3.417.709 3.417 1.613s-.769 1.33-2.303 1.33c-1.416 0-2.467-.644-3.102-1.896a.186.186 0 0 0-.251-.082L.14 16.21a.188.188 0 0 0-.083.253c1.051 2.102 3.207 3.285 6.087 3.285 3.668 0 5.885-1.698 5.885-4.527 0-2.83-2.677-3.651-5.037-4.16v-.007ZM21.218 5.311c-1.505 0-2.835.531-3.791 1.477-.06.057-.159.015-.159-.067V.687A.185.185 0 0 0 17.081.5h-3.322a.185.185 0 0 0-.187.187v18.73c0 .104.083.186.187.186h3.322a.185.185 0 0 0 .187-.186V11.2c0-1.587 1.223-2.804 2.87-2.804 1.649 0 2.843 1.191 2.843 2.804v8.216c0 .104.082.186.187.186h3.322a.185.185 0 0 0 .187-.186V11.2c0-3.452-2.274-5.89-5.459-5.89ZM33.415 4.774c-1.803 0-3.493.55-4.706 1.343a.186.186 0 0 0-.06.25l1.464 2.488c.054.089.168.12.257.066a5.853 5.853 0 0 1 3.052-.834c2.899 0 5.03 2.036 5.03 4.726 0 2.292-1.706 3.99-3.868 3.99-1.762 0-2.985-1.022-2.985-2.463 0-.825.352-1.502 1.27-1.98a.183.183 0 0 0 .073-.258l-1.381-2.327a.187.187 0 0 0-.226-.079c-1.85.683-3.15 2.327-3.15 4.533 0 3.338 2.67 5.83 6.396 5.83 4.35 0 7.478-3 7.478-7.303 0-4.612-3.64-7.982-8.644-7.982ZM51.776 5.283c-1.68 0-3.182.62-4.277 1.707a.093.093 0 0 1-.16-.066v-1.31a.185.185 0 0 0-.187-.186h-3.235a.185.185 0 0 0-.188.187v18.702c0 .104.083.186.188.186h3.32a.185.185 0 0 0 .188-.186v-6.133c0-.082.099-.123.16-.07 1.091 1.012 2.536 1.603 4.19 1.603 3.897 0 6.936-3.139 6.936-7.217 0-4.078-3.042-7.217-6.935-7.217Zm-.63 11.266c-2.215 0-3.895-1.754-3.895-4.074S48.928 8.4 51.147 8.4c2.22 0 3.893 1.726 3.893 4.075 0 2.348-1.651 4.074-3.896 4.074h.003Z"></path></svg></div>
        </div>
        <style>
          .mobile-injected {
            display: inline;
          }
          @media (min-width: 1024px) {
            .mobile-injected {
              display: none;
            }
          }
          *:has(>.inline-flex.align-middle.text-purple-primary) .mobile-injected {
            display: none !important;
          }
        </style>
      `
    }
  },0);

  this.displayPrice.forEach(el => {
    if (el.dataset.displayPrice === 'simple') {
      el.innerHTML = product?.price_money;
      return;
    }

    const tags_to_check = this.tagsForTagPriceColor.split(`,`);
    const has_exclusion_tag = tags_to_check.some(tag => this.selectedProduct.tags.includes(tag));
    const sale_style = (!has_exclusion_tag && product?.compare_at_price > product?.price) ? `style="color:${this.saleColor}; font-weight:${this.saleWeight}"` : '';

    el.innerHTML = product?.compare_at_price > product?.price
      ? `
        <span data-product-id="${product.id}" data-sale-price class="text-primaryDark empty:hidden" ${sale_style}>${this.currencySymbol}${(product?.price / 100)}</span>
        <span data-product-id="${product.id}" data-compare-price class="line-through text-primaryDark empty:hidden">${this.currencySymbol}${(product?.compare_at_price / 100)}</span>
      `
      : 
      `<span data-price data-product-id="${product.id}" class="text-primaryDark empty:hidden igPrice">${this.currencySymbol}${(product?.price / 100)}</span>`;

    const discount_badges = this.querySelectorAll('[data-tag-messages]');
    const discount_tags = [];
    this.selectedProduct.tags.forEach(tag => {
      if (tag === 'discount-auto' || tag === 'sale') {
        const discount_percent = Math.floor(((product.compare_at_price - product.price) * 100) / product.compare_at_price);
        discount_tags.push(`${discount_percent}% off`);
      } else if (tag.includes('discount-message')) {
        const message = tag.split(' | ').pop();
        discount_tags.push(message);
      }
    });
    
    discount_badges.forEach(discount_badges => {
      discount_badges.classList.remove('hidden');

      if (discount_tags.length === 0) {
        discount_badges.classList.add('hidden');
      } else {
        discount_badges.innerHTML = `
          ${discount_tags.map(tag => (`
            <span class="tag-msg bg-primaryBrand border border-primaryDark px-2 py-0.5 text-primaryDark text-xs font-medium rounded-full leading-3">${tag}</span>
          `)).join('')}
        `;
      }
    });
  });
} 
    
function restoreFocusAfter(container, fn) {
  const focusedInput = document.activeElement;
  const focusedValue = focusedInput?.dataset?.option;
  const focusedOptionType = focusedInput?.dataset?.optionType;
  const focusedInContainer = focusedValue && container.contains(focusedInput);

  fn();

  if (focusedInContainer) {
    const restored = container.querySelector(
      `input[data-option="${focusedValue}"][data-option-type="${focusedOptionType}"]`
    );
    if (restored) restored.focus();
  }
}

function populateSelectedProductOptions() {
  this.displayOptions = this.querySelector('[data-display-options]');
  if (!this.displayOptions || !this.selectedProduct || !this.currentVariant) return;
  const widths = this.gender == 'women' ? ['Narrow (A)', 'Medium (B)', 'Wide (D)', 'X-Wide (2E)', 'XX-Wide (4E)'] : ['Narrow (B)', 'Medium (D)', 'Wide (2E)', 'X-Wide (4E)', 'XX-Wide (6E)'];
  const isSock = this.selectedProduct.type.toLowerCase().includes('sock') ? true : false
  const optionsHTMLString = this.selectedProduct.options_with_values.map(({ name, values }, index) => {
    const isWidth = ["width", "breite", "largeur"].includes(name.toLowerCase().trim());
    if (values.length < 1) return;
    let colspan = "";
    let type = "";
    if (isWidth) {
      const num_options = values.length 
      const by_4 = num_options % 4
      const by_5 = num_options % 5
      if (by_4 == 0) {
        colspan = '[&>*:last-child]:!col-span-6'
      } else if (by_5 == 0) { 
        colspan = '[&>*:nth-last-child(-n+2)]:!col-span-3'
      }
    } 
    if(isSock) type = 'sock-selector'
    return `
      <div data-option-type="${name.toLowerCase().trim()}" class="${values.length <= 1 && !isWidth ? 'hidden' : ''}">
        <div class="title-wrap">
          <span class="flex">
            <span>${name}:&nbsp;</span>
            <span data-${name.toLowerCase().trim()}-title class="font-semibold">
              ${this.currentVariant.options[index]}
            </span>
          </span>
          ${name.toLowerCase().includes('size') ? `
            <button type="button" data-drawer-action="open" data-drawer-id="size-chart">Size &amp; Fit Chart</button>
          ` : ''}
        </div>
        <div class="selector-section">
          <ul class="selector-list ${colspan} ${type}">
            ${values.map((value) => {
              const indexOfOption = this.selectedProduct.options_with_values
                .findIndex(({ values }) => {
                  return values.find((x) => x === value);
                });
              const currentOptionSet =  [...this.querySelectorAll('[data-action="option-choice"][data-option]:checked')].map(({ value }) => value)
              let thisOptionSet = [...this.currentVariant.options];
              thisOptionSet[indexOfOption] = value;
              const matchingProduct = this.selectedProduct.variants.find(({ options}) => {
                return options.every(( option ) => thisOptionSet.find((thisOption) => thisOption === option));
              });

              let matchedWidth = name.toLowerCase().trim() == 'width' && Shopify.country != 'DE' ? widths.find(width => width.startsWith(value)) : value
                      
              return `
                <li>
                  <div class="${(matchingProduct?.available && this.readyToAdd || !this.readyToAdd) ? '' : 'unavailable'} selector-wrap">
                    <input 
                      data-action="option-choice"
                      data-option="${value}"
                      data-option-type="${name}"
                      id="${this.selectedProduct.id}-${value}" 
                      type="radio"
                      value="${value}"
                      name="${name}"
                      ${(this.readyToAdd ? (this.currentVariant.options.find((option) => option === value)) : (currentOptionSet.find((option) => option === value))) ? 'checked' : ''}
                    >
                    <span class="selector">    
                      <span class="strikethough">
                        <svg class="relative w-full h-full stroke-primaryDark opacity-50" viewBox='0 0 10 10' preserveAspectRatio='none'>
                          <line x1='10' y1='0' x2='0' y2='10' stroke-width='0.5' stroke-opacity='0.5' />
                        </svg>
                      </span>    
                      <span class="selector-label">${matchedWidth}</span>
                    </span>                      
                  </div>
                </li>
            `
            }).join('')}
          </ul>
        </div>
      </div>`
    }).join('')
  restoreFocusAfter(this.displayOptions, () => {
    this.displayOptions.innerHTML = optionsHTMLString;
  });
}